import $ from "jquery";

// Container is the container of all the items you want to filter
// elementSelector is the selector used to find the elements
// searchSelectors is an array of selectors for elements to search within
export default class ElementFilter {
  constructor(container, elementSelector, searchSelectors) {
    this.container = container || $(document);
    this.elementSelector = elementSelector;
    this.searchSelectors = searchSelectors;
  }

  // Filter the items by the given text
  filter(text) {
    const matching = this.findMatchingElements(text);
    this.container.find(this.elementSelector).not(matching).hide();
    matching.show();
    this.container.trigger("filtered.wd");
  }

  // Find all elements in container
  findElements() {
    return this.container.find(this.elementSelector);
  }

  // Find elements in container that match given text
  findMatchingElements(text = "") {
    if (text == "") {
      return this.findElements();
    } else {
      const selector = this.buildSearchSelector(text);
      return this.findElements().find(selector).closest(this.elementSelector);
    }
  }

  // Build the jQuery selector for finding matching elements
  buildSearchSelector(text) {
    text = text.replace("\"", "\\\""); // wtf
    return this.searchSelectors.map((selector) => {
      return `${selector}:caseless_contains("${text}")`;
    }).join(", ");
  }
}
